import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Button from '../components/Button';
import api from '../services/api';
import { useNavigate, Link } from 'react-router-dom';
import ChequePagarModal from '../components/ChequePagarModal';
import { FaHome } from 'react-icons/fa'; // ou use 'IoHome' de 'react-icons/io5'
import ConfirmModal from '../components/ConfirmModal';
const instancia = process.env.REACT_APP_INSTANCIA;

// Styled Components reutilizados do seu projeto
const ContentContainer = styled.div`
  flex: 1;
  padding: 24px;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
`;

const SectionHeading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px; 
`;

const SectionTitle = styled.h2`
  font-size: 18px;
  color: #333;
`;

const TableContainer = styled.div`
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  overflow: hidden;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const Th = styled.th`
  text-align: left;
  padding: 5px;
  font-size: 14px;
  font-weight: 600;
  color: #666;
  background-color: #f9f9f9;
  border-bottom: 1px solid #e1e1e1;
`;

const Td = styled.td`
  padding: 8px;
  font-size: 14px;
  border-bottom: 1px solid #e1e1e1;
`;

const StatusBadge = styled.span`
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  background-color: ${props => {
        switch (props.status) {
            case 'BAIXADO':
                return '#e6f7ed';
            case 'CANCELADO':
                return '#fee6e6';
            default:
                return '#fff8e6';
        }
    }};
  color: ${props => {
        switch (props.status) {
            case 'BAIXADO':
                return '#2ecc71';
            case 'CANCELADO':
                return '#e74c3c';
            default:
                return '#f39c12';
        }
    }};
`;

const ActionButton = styled.button`
  background: none;
  border: none;
  color: #6c5ce7;
  font-size: 14px;
  cursor: pointer;
  padding: 5px 10px;
  margin-right: 5px;
  border-radius: 4px;
  transition: background-color 0.3s;
  &:hover {
    background-color: rgba(108, 92, 231, 0.1);
  }
`;

const EmptyState = styled.div`
  text-align: center;
  padding: 40px;
  color: #666;
`;

const Cheques = () => {
    const navigate = useNavigate();
    const [cheques, setCheques] = useState([]);
    const [fornecedores, setFornecedores] = useState([]);
    const [isChequeModalOpen, setIsChequeModalOpen] = useState(false);
    const [currentCheque, setCurrentCheque] = useState(null); // Para edição
    const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
    const [confirmAction, setConfirmAction] = useState(null);
    const [confirmMessage, setConfirmMessage] = useState('');
    const [contaCorrente, setContaCorrente] = useState([]);
    const [contaSelecionada, setContaSelecionada] = useState('');

    const [inicio, setInicio] = useState('0000-00-00');
    const [fim, setFim] = useState('0000-00-00');
    const [status, setStatus] = useState('TODOS');

    const [pagina, setPagina] = useState(0);
    const [totalPaginas, setTotalPaginas] = useState(0);
    const [totalizador, setTotalizador] = useState("0,00");

    // Pegar mes atual
    useEffect(() => {
        const hoje = new Date();
        const primeiroDia = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
        const ultimoDia = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);

        const formatarData = (data) =>
            data.toISOString().split("T")[0];

        setInicio(formatarData(primeiroDia));
        setFim(formatarData(ultimoDia));
    }, []);

    // Carregar dados fornecedor e conta corrente
    useEffect(() => {
        (async () => {

            const token = localStorage.getItem('token');
            if (!token) {
                navigate('/');
                return;
            }

            // Buscar fornecedores 
            await fetchFornecedores();

            // Buscar conta corrente
            await fetchContaCorrente();

        })();
    }, []);

    // Atualizar o cheque assim que mexer no filtro
    useEffect(() => {
        fetchCheques();
    }, [inicio, fim, status, pagina, contaSelecionada]);

    const fetchFornecedores = async () => {
        try {
            const retorno = await api.get(`/fornecedores/${instancia}/todos`);
            if (retorno && retorno.status === 200) {
                setFornecedores(retorno.data);
            }
        } catch (error) {
            alert(error);
        }
    }

    const fetchContaCorrente = async () => {
        try {
            const retorno = await api.get(`/contacorrente/${instancia}`);
            if (retorno && retorno.status === 200) {
                setContaCorrente(retorno.data);
            }
        } catch (error) {
            alert(error);
        }
    }

    const fetchCheques = async () => {
        try {
            if (inicio === '0000-00-00') return;
            const retorno = await api.get('/chequesPagar', {
                params: {
                    dataI: inicio,
                    dataF: fim,
                    status: status.toUpperCase(),
                    fornecedor: 0,
                    instancia: `${instancia}`,
                    pagina,
                    contaSelecionada
                }
            });

            if (retorno && retorno.data) {
                setCheques(retorno.data.chequesFormatados || []);
                setTotalPaginas(Math.ceil(retorno.data.total / 8));
                setTotalizador(retorno.data.totalizador || "0,00"); // 👈 aqui
            } else {
                setCheques([]);
                setTotalPaginas(0);
            }
        } catch (error) {
            alert(error);
        }
    };

    const handleExcluir = async (id) => {
        try {
            const retorno = await api.delete(`/chequesPagar/${id}/${instancia}`);
            fetchCheques();
            // setCheques(cheques.filter(ch => ch.COD_CHEQUE !== id));
        } catch (error) {
            alert(error)
        }

    };

    // Função de baixa
    const handleBaixar = async (id, st) => {
        try {
            const retorno = await api.put('/chequesPagar/baixar', {
                instancia: `${instancia}`,
                cod_cheque: id,
                status: st
            });
            fetchCheques()
        } catch (error) {
            alert(error);
        }
    };

    const handleSalvar = async (cheque) => {
        try {

            const usuario = localStorage.getItem('codigoUsuarioLogado');

            const obj = {
                cod_usuario: usuario,
                cod_fornecedor: cheque.codFornecedor,
                cnpj_cpf: cheque.cpfCnpj,
                valor: cheque.valor,
                banco: cheque.banco,
                numero: cheque.numero,
                emissao: cheque.emissao,
                vencimento: cheque.vencimento,
                instancia: `${instancia}`,
                cod_cheque: cheque.cod_cheque,
                codContaCorrente: cheque.codContaCorrente,
                obs: cheque.observacao
            }

            await api.post('/chequesPagar', obj);
            fetchCheques();
        } catch (error) {
            alert(error);
        }
    }

    const showConfirmModal = (message, action) => {
        setConfirmMessage(message);
        setConfirmAction(() => action);
        setIsConfirmModalOpen(true);
    };

    const handleConfirm = () => {
        if (confirmAction) confirmAction();
        setIsConfirmModalOpen(false);
    };

    const handleCancel = () => {
        setIsConfirmModalOpen(false);
    };

    return (
        <ContentContainer>

            <ChequePagarModal
                isOpen={isChequeModalOpen}
                onClose={() => setIsChequeModalOpen(false)}
                onSave={(data) => {
                    handleSalvar(data);
                }}
                initialData={currentCheque}
            />

            <ConfirmModal
                isOpen={isConfirmModalOpen}
                onClose={handleCancel}
                onConfirm={handleConfirm}
                message={confirmMessage}
            />


            <SectionHeading>
                <div >
                    <Button
                        variant="primary"
                        size="small"
                        onClick={() => {
                            setCurrentCheque(null);
                            setIsChequeModalOpen(false);
                            navigate('/home');
                        }}
                    >
                        <FaHome style={{ marginRight: '8px' }} /> {/* Ícone à esquerda */}
                        Home
                    </Button>
                </div>


                <div style={{ margin: 'auto' }}>
                    <Button
                        variant="primary"
                        size="small"
                        onClick={() => {
                            setCurrentCheque(null);
                            setIsChequeModalOpen(true);
                        }}
                    >
                        Novo Cheque
                    </Button>
                </div>
            </SectionHeading>

            {/* Filtros */}
            <div style={{ marginBottom: '20px', display: 'flex', gap: '16px', alignItems: 'center' }}>
                <div>
                    <label>Data Início:</label>
                    <input
                        type="date"
                        value={inicio}
                        onChange={(e) => setInicio(e.target.value)}
                        style={{ borderRadius: 10, height: 30, gap: 10, display: 'flex', textAlign: 'center', border: 'none', fontSize: 16, marginTop: 10, color: '#fff', backgroundColor: 'blueviolet' }}
                    />
                </div>

                <div>
                    <label>Data Fim:</label>
                    <input
                        type="date"
                        value={fim}
                        onChange={(e) => setFim(e.target.value)}
                        style={{ borderRadius: 10, height: 30, gap: 10, display: 'flex', textAlign: 'center', border: 'none', fontSize: 16, marginTop: 10, color: '#fff', backgroundColor: 'blueviolet' }}
                    />
                </div>

                <div>
                    <label>Status:</label>
                    <select
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                        style={{ borderRadius: 10, height: 30, gap: 10, display: 'flex', textAlign: 'center', border: 'none', fontSize: 16, marginTop: 10, color: '#fff', backgroundColor: 'blueviolet' }}
                    >
                        <option value="TODOS">Todos</option>
                        <option value="ABERTO">Aberto</option>
                        <option value="BAIXADO">Baixado</option>
                        <option value="CANCELADO">Cancelado</option>
                    </select>
                </div>

                <div>
                    <label>Conta Corrente:</label>
                    <select
                        value={contaSelecionada}
                        onChange={(e) => setContaSelecionada(e.target.value)}
                        style={{
                            borderRadius: 10,
                            height: 30,
                            display: 'flex',
                            textAlign: 'center',
                            border: 'none',
                            fontSize: 16,
                            marginTop: 10,
                            color: '#fff',
                            backgroundColor: 'blueviolet',
                        }}
                    >
                        <option value="">Todas</option>
                        {contaCorrente.map((conta) => (
                            <option key={conta.COD} value={conta.COD}>
                                {conta.BANCO} / Ag. {conta.AGENCIA} / Conta {conta.NUMERO_CONTA}
                            </option>
                        ))}
                    </select>
                </div>


                <div style={{ display: 'flex', justifyContent: 'flex-end', width: '50%', marginTop: '10px', marginRight: '80px', fontWeight: 'bold', fontSize: 20, color: '#333' }}>
                    Total em cheques ({status.toLowerCase()}): R$ {totalizador}
                </div>


            </div>

            <TableContainer>
                <Table>
                    <thead>
                        <tr>
                            <Th>Banco</Th>
                            <Th>Número</Th>
                            <Th>Fornecedor</Th>
                            <Th>Valor</Th>
                            <Th>Emissão</Th>
                            <Th>Vencimento</Th>
                            <Th>Status</Th>
                            <Th>Ações</Th>
                        </tr>
                    </thead>
                    <tbody>
                        {cheques.length > 0 ? (
                            cheques.map((cheque) => (
                                <tr key={cheque.COD_CHEQUE}>
                                    <Td>{cheque.BANCO}</Td>
                                    <Td>{cheque.NUMERO}</Td>
                                    <Td>{cheque.nome}</Td>
                                    <Td>R$ {cheque.VALOR}</Td>
                                    <Td>{new Date(cheque.EMISSAO).toLocaleDateString('pt-BR')}</Td>
                                    <Td>{new Date(cheque.VENCIMENTO).toLocaleDateString('pt-BR')}</Td>
                                    <Td>
                                        <StatusBadge status={cheque.STATUS}>{cheque.STATUS}</StatusBadge>
                                    </Td>
                                    <Td>
                                        {cheque.STATUS !== "BAIXADO" && (
                                            <ActionButton onClick={() => {
                                                setCurrentCheque(cheque);
                                                setIsChequeModalOpen(true);
                                            }}>
                                                Alterar
                                            </ActionButton>
                                        )}

                                        {cheque.STATUS !== "BAIXADO" && (
                                            <ActionButton
                                                onClick={() =>
                                                    showConfirmModal(
                                                        'Tem certeza que deseja baixar este cheque?',
                                                        () => handleBaixar(cheque.COD_CHEQUE, 'BAIXADO')
                                                    )
                                                }
                                            >
                                                Baixar
                                            </ActionButton>
                                        )}

                                        {cheque.STATUS === "BAIXADO" && (
                                            <ActionButton
                                                onClick={() =>
                                                    showConfirmModal(
                                                        'Tem certeza que deseja cancelar baixar este cheque?',
                                                        () => handleBaixar(cheque.COD_CHEQUE, 'PENDENTE')
                                                    )
                                                }
                                            >
                                                Cancelar a Baixa
                                            </ActionButton>
                                        )}

                                        {cheque.STATUS !== "BAIXADO" && (
                                            // <ActionButton onClick={() => handleExcluir(cheque.COD_CHEQUE)}>Excluir</ActionButton>
                                            <ActionButton
                                                onClick={() =>
                                                    showConfirmModal(
                                                        'Tem certeza que deseja excluir este cheque?',
                                                        () => handleExcluir(cheque.COD_CHEQUE)
                                                    )
                                                }
                                            >
                                                Excluir
                                            </ActionButton>
                                        )}

                                    </Td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="7">
                                    <EmptyState>Nenhum cheque encontrado.</EmptyState>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </TableContainer>

            {/* Paginação */}
            <div style={{ display: 'flex', justifyContent: 'center', gap: '16px', marginTop: '16px' }}>
                <button
                    style={{ width: 120, height: 40, border: 'none', borderRadius: 10, color: '#fff', backgroundColor: 'blue' }}
                    disabled={pagina <= 0}
                    onClick={() => setPagina(prev => prev - 1)}
                >
                    Anterior
                </button>
                <span style={{ alignSelf: 'center' }}>Página {pagina + 1} de {totalPaginas}</span>
                <button
                    style={{ width: 120, height: 40, border: 'none', borderRadius: 10, color: '#fff', backgroundColor: 'blue' }}
                    disabled={pagina >= totalPaginas - 1}
                    onClick={() => setPagina(prev => prev + 1)}
                >
                    Próximo
                </button>
            </div>

        </ContentContainer>
    );
};

export default Cheques;